import { PORTFOLIO_DAYS_BY_PERIOD } from 'src/components/PortfolioPage/consts';
import { PortfolioPeriod } from 'src/components/PortfolioPage/types';
import { PortfolioTradeChartTabValue } from 'src/components/PortfolioPage/PortfolioTradeSubPage/types';

interface Params {
	period: PortfolioPeriod;
	tradeChartTab: PortfolioTradeChartTabValue;
}

export default function getPortfolioTradeChartMaxSnapshots({
	period,
	tradeChartTab,
}: Params) {
	// Depending on the months, we may need more than 90, so we don't limit for calendar.
	if (tradeChartTab === 'calendar') {
		return;
	}

	// For cumulative, just use a max cap of 90.
	if (tradeChartTab === 'cumulative') {
		return 90;
	}

	// Intervals are a bit different, because we want to show exactly N interval bars.
	if (period === '24h') {
		return 24;
	}

	if (period === '90d') {
		return 90;
	}

	return PORTFOLIO_DAYS_BY_PERIOD[period];
}
